module.exports = __webpack_public_path__ + "static/media/Project3_Fig30.c1d97b56.png";